export const UserRepositoryToken = Symbol('UserRepository');
export const UserStatusRepositoryToken = Symbol('UserStatusRepository');
export const DateFormatterToken = Symbol('DateFormatter');
export const PingRepositoryToken = Symbol('PingRepository');
export const UserSessionRepositoryToken = Symbol('UserSessionRepositoryToken');
export const FacilityAccessCheckerToken = Symbol('FacilityAccessCheckerToken');
export const NotificationServiceToken = Symbol('NotificationServiceToken');
export const PauseRepositoryToken = Symbol('PauseRepositoryToken');
